"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBLogo", {
  enumerable: true,
  get: function get() {
    return _SVBLogo.default;
  }
});
var _SVBLogo = _interopRequireDefault(require("./src/SVBLogo"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }